module.exports = __webpack_public_path__ + "img/logo.3259a98f.svg";